<mat-expansion-panel [expanded]="!model.isProcessed && !model.isProcessing" [hideToggle]="!model.isProcessed" (opened)="openPanel()" [disabled]="!model.isProcessed">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="flex justify-between content-center items-center flex-row basis-full">
        <div class="flex flex-row justify-start content-center items-center h-full">
          <div>
            <h3 [ngClass]="{ 'gray': model.isProcessed, 'black' : !model.isProcessed, 'pulsate': model.isProcessing }">{{ model.name }}</h3>
          </div>
          @if (isLoadingBuildingInfo) {
            <div class="ml1">
              <mat-spinner diameter="16"></mat-spinner>
            </div>
          }
          @if (showBuildingLink()) {
            <button mat-icon-button="" (click)="openBuilding()" [matTooltip]="'Open building (new window)' | translate">
              <mat-icon class="openBuildingIcon">open_in_new</mat-icon>
            </button>
          }
          <div class="ml1">
            @if (model.isProcessing) {
              <mat-spinner diameter="18"></mat-spinner>
            }
            @if (model.isProcessed) {
              <mat-icon class="green">check</mat-icon>
            }
          </div>
        </div>
        @if (showPurchaseLabel(form)) {
          <div>
            <span class="green" translate="">new purchase</span>
          </div>
        }
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div>

    <div class="basis-full">
      @if (isCombinationBuilding(form)) {
        <mat-table [dataSource]="unitsDataSource" matSort="" matSortDisableClear="" style="width: 100%" class="mb2">
          <ng-container matColumnDef="label">
            <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-56">
            </mat-header-cell>
            <mat-cell *matCellDef="let unitRow;" style="padding-left: 0 !important;" class="grow-0 shrink-0 basis-56">
              <span>{{unitRow.address.addressLine1}}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[155px]">
              <span translate="">Building type</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-[155px]">
              <unite-list-item-select type="unitType" [control]="unitRow.form.get('type')">
              </unite-list-item-select>
            </mat-cell>
          </ng-container>
          <!-- <ng-container matColumnDef="surface">
          <mat-header-cell *matHeaderCellDef class="grow-0 shrink-0 basis-[80px]">
            <span translate>Surface</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-[80px]">
            <unite-input-field [control]="unitRow.form.get('surface')"  classField="inline-field" type="digits" required>
            </unite-input-field>
          </mat-cell>
        </ng-container> -->
        <ng-container matColumnDef="finalEnergyLabel">
          <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-20">
            <span translate="">Energy label</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-20">
            <unite-list-item-select [control]="unitRow.form.get('finalEnergyLabel')" classField="inline-field" type="energyLabel" required="">
            </unite-list-item-select>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rented">
          <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-20">
            <span translate="">Rented</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-20">
            <unite-list-item-select [control]="unitRow.form.get('rented')" classField="inline-field" type="boolean" required="">
            </unite-list-item-select>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rentalType">
          <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[150px]">
            <span translate="">Rental type</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-[150px]">
            <unite-list-item-select [control]="unitRow.form.get('rentalType')" classField="inline-field" type="rentalType" required="">
            </unite-list-item-select>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rentIncome">
          <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-full">
            <span translate="">Rent per month</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-full">
            @if (unitRow.form.get('rented')?.value) {
              <unite-input-field [control]="unitRow.form.get('currentRentIncome')" classField="inline-field" type="financial" required="">
              </unite-input-field>
            }
            @if (!unitRow.form.get('rented')?.value) {
              <unite-input-field [control]="unitRow.form.get('estimatedRentalValue')" classField="inline-field" type="financial" required="">
              </unite-input-field>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rentalPoints">
          <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[180px]">
            <span translate="">WWS-points by landlord</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-[180px]">
            <unite-input-field [control]="unitRow.form.get('pointsRent')?.get('manualPoints')" classField="inline-field" type="digits" required="">
            </unite-input-field>
          </mat-cell>
        </ng-container>
        <!-- <ng-container matColumnDef="estimatedValueByMunicipality">
        <mat-header-cell *matHeaderCellDef class="grow-0 shrink-0 basis-[100px]">
          <span translate>WOZ-value</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-[100px]">
          <unite-input-field [control]="unitRow.form.get('estimatedValueByMunicipality')"  classField="inline-field" type="financial" required>
          </unite-input-field>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="estimatedValueByMunicipalityDate">
        <mat-header-cell *matHeaderCellDef class="grow-0 shrink-0 basis-[160px]">
          <span translate>WOZ-value reference date</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let unitRow;" class="grow-0 shrink-0 basis-[160px]">
          <unite-input-field [control]="unitRow.form.get('estimatedValueByMunicipalityDate')"  classField="inline-field" type="date" required>
          </unite-input-field>
        </mat-cell>
      </ng-container> -->
      <mat-header-row *matHeaderRowDef="unitsDisplayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: unitsDisplayedColumns;"></mat-row>
    </mat-table>
    @if (unitsDataSource.data?.length === 0) {
      <p translate="">
        No units found
      </p>
    }
  }

  <mat-list class="smaller-list xxl-labels medium">
    @if (form.get('type')?.enabled) {
      <unite-list-item-select [label]="'Type' | translate" type="buildingType" [control]="form.get('type')">
      </unite-list-item-select>
    }

    @if (!statusPrefilled) {
      <unite-list-item-select [label]="'Status' | translate" type="buildingStatus" [control]="form.get('status')">
      </unite-list-item-select>
    }

    <mat-list-item>
      <label [class.warning]="form.get('purpose')?.touched && form.get('purpose')?.invalid" translate="">Purpose</label>
      <mat-form-field floatLabel="never" class="inline-field">
        <mat-select placeholder="..." [formControl]="form.get('purpose')">
          <mat-option [value]="'Rent'"><span translate="">Rent</span></mat-option>
          <mat-option [value]="'Sell'"><span translate="">Sell</span></mat-option>
          <mat-option [value]="'OwnUse'"><span translate="">Own use</span></mat-option>
        </mat-select>
      </mat-form-field>
    </mat-list-item>

    @if (form.get('rented')?.enabled) {
      <unite-list-item-select [label]="'Currently rented out' | translate" type="boolean" [control]="form.get('rented')">
      </unite-list-item-select>
    }

    @if (form.get('rentalType')?.enabled) {
      <unite-list-item-select [control]="form.get('rentalType')" [label]="'Rental type' | translate" type="rentalType">
      </unite-list-item-select>
    }

    <ng-template *ngTemplateOutlet="tplRent; context: {$implicit: form}"></ng-template>

    @if (form.get('estimatedRentalValue')?.enabled) {
      <unite-list-item-input [label]="'Rent per month' | translate" type="financial" [control]="form.get('estimatedRentalValue')" [tooltip]="'The (expected) basic rent per month. The basic rent is the rent excluding service costs and other costs.' | translate">
      </unite-list-item-input>
    }

    @if (form.get('currentRentIncome')?.enabled) {
      <unite-list-item-input [label]="'Rent per month' | translate" type="financial" [control]="form.get('currentRentIncome')" [tooltip]="'The (expected) basic rent per month. The basic rent is the rent excluding service costs and other costs.' | translate">
      </unite-list-item-input>
    }

    @if (form.get('willBeRenovated')?.enabled) {
      <unite-list-item-select [label]="'Renovation planned' | translate" [tooltip]="'Will the object be renovated before it is rented or sold?' | translate" type="boolean" [control]="form.get('willBeRenovated')">
      </unite-list-item-select>
    }

    @if (form.get('renovationCosts')?.enabled) {
      <unite-list-item-input [label]="'Total renovation costs' | translate" type="financial" [control]="form.get('renovationCosts')">
      </unite-list-item-input>
    }

    @if (form.get('renovationPermitsRequired')?.enabled) {
      <unite-list-item-select [label]="'Permits required' | translate" type="boolean" [control]="form.get('renovationPermitsRequired')">
      </unite-list-item-select>
    }

    @if (form.get('purchaseDate')?.enabled) {
      <unite-list-item-input [label]="'Purchase date' | translate" type="date" [control]="form.get('purchaseDate')">
      </unite-list-item-input>
    }

    @if (form.get('purchaseValue')?.enabled) {
      <unite-list-item-input [label]="'Purchase value' | translate" type="financial" [control]="form.get('purchaseValue')" [tooltip]="'The price for which the property is acquired excluding transfer tax and other purchase costs.' | translate">
      </unite-list-item-input>
    }

    @if (form.get('groundLease')?.enabled) {
      <unite-list-item-select [label]="'Ground lease' | translate" type="boolean" [control]="form.get('groundLease')">
      </unite-list-item-select>
    }

    @if (form.get('valueInRentedCondition')?.enabled) {
      <unite-list-item-input classItem="red" [label]="'Value in rented condition' | translate" type="financial" [control]="form.get('valueInRentedCondition')" [tooltip]="'The price a real estate investor is willing to pay for a property that is rented out.' | translate">
      </unite-list-item-input>
    }

    @if (form.get('valueInRentedConditionResidential')?.enabled) {
      <unite-list-item-input classItem="red" [label]="'Value in rented condition residential' | translate" type="financial" [control]="form.get('valueInRentedConditionResidential')" [tooltip]="'The price a real estate investor is willing to pay for a property that is rented out.' | translate">
      </unite-list-item-input>
    }

    @if (form.get('valueInRentedConditionCommercial')?.enabled) {
      <unite-list-item-input classItem="red" [label]="'Value in rented condition commercial' | translate" type="financial" [control]="form.get('valueInRentedConditionCommercial')" [tooltip]="'The price a real estate investor is willing to pay for a property that is rented out.' | translate">
      </unite-list-item-input>
    }

    @if (form.get('valueInRentedConditionAfterRenovation')?.enabled) {
      <unite-list-item-input [label]="'Value in rented condition after renovation' | translate" type="financial" [control]="form.get('valueInRentedConditionAfterRenovation')" [tooltip]="'The price a real estate investor is willing to pay for a property after renovation that is rented out.' | translate">
      </unite-list-item-input>
    }

    @if (form.get('expectedValue')?.enabled) {
      <unite-list-item-input [label]="'Expected sale value' | translate" type="financial" [control]="form.get('expectedValue')">
      </unite-list-item-input>
    }

    @for (unit of units; track unit) {
      <div class="mt1">
        <label><strong translate="">{{unit.address.addressLine1}}</strong></label>
        <ng-template *ngTemplateOutlet="tplRent; context: {$implicit: unit.form}">
        </ng-template>
        @if (unit.form.get('surface')?.enabled) {
          <unite-list-item-input classItem="red" [label]="'Surface' | translate" type="digits" suffix="m<sup>2</sup>" [control]="unit.form.get('surface')" [tooltip]="'The surface area of the property in square meters' | translate">
        </unite-list-item-input>
      }
      @if (unit.form.get('estimatedValueByMunicipality')?.enabled) {
        <unite-list-item-input classItem="red" [label]="'WOZ-value' | translate" type="financial" tooltip="De (geschatte) WOZ-waarde wordt o.a. voor het bepalen van de exploitatiekosten en de puntentelling bij woningen." [control]="unit.form.get('estimatedValueByMunicipality')">
        </unite-list-item-input>
      }
      @if (unit.form.get('estimatedValueByMunicipalityDate')?.enabled) {
        <unite-list-item-input classItem="red" [label]="'WOZ-value reference date' | translate" type="date" [control]="unit.form.get('estimatedValueByMunicipalityDate')">
        </unite-list-item-input>
      }
      @if (unit.form.get('pointsRent')?.get('totalPoints').enabled) {
        <unite-list-item-read classItem="red" [label]="'WWS-points by estimation' | translate" type="decimal" tooltip="De berekende punten van het pand. Deze worden berekend op basis van de belangrijkste factoren: oppervlakte, energielabel en WOZ-waarde. Er kunnen extra punten worden toegekend bij bijvoorbeeld extra voorzieningen, een luxe afwerking, extra buitenruimte, een parkeerplaats, of indien het pand een rijksmonument of stadsgezicht betreft." [value]="unit.form.get('pointsRent')?.get('totalPoints').value">
        </unite-list-item-read>
      }
      <!-- <unite-list-item-input *ngIf="unit.form.get('pointsRent')?.get('manualPoints').enabled"
      classItem="red"
      [label]="'WWS-points by landlord' | translate"
      type="decimal"
      [control]="unit.form.get('pointsRent')?.get('manualPoints')">
    </unite-list-item-input> -->
  </div>
}

@if (form.get('surface')?.enabled) {
  <unite-list-item-input classItem="red" [label]="'Surface' | translate" type="digits" suffix="m<sup>2</sup>" [control]="form.get('surface')" [tooltip]="'The surface area of the property in square meters' | translate">
</unite-list-item-input>
}

@if (form.get('finalEnergyLabel')?.enabled) {
  <unite-list-item-select classItem="red" [label]="'Energy label' | translate" type="energyLabel" [control]="form.get('finalEnergyLabel')">
  </unite-list-item-select>
}

@if (form.get('energyLabelAfterRenovation')?.enabled) {
  <unite-list-item-input classItem="red" [label]="'Energy label after renovation' | translate" type="energyLabel" [control]="form.get('energyLabelAfterRenovation')">
  </unite-list-item-input>
}

@if (form.get('estimatedValueByMunicipality')?.enabled) {
  <unite-list-item-input classItem="red" [label]="'WOZ-value' | translate" type="financial" tooltip="De (geschatte) WOZ-waarde wordt o.a. voor het bepalen van de exploitatiekosten en de puntentelling bij woningen." [control]="form.get('estimatedValueByMunicipality')">
  </unite-list-item-input>
}

@if (form.get('estimatedValueByMunicipalityDate')?.enabled) {
  <unite-list-item-input classItem="red" [label]="'WOZ-value reference date' | translate" type="date" [control]="form.get('estimatedValueByMunicipalityDate')">
  </unite-list-item-input>
}

@if (form.get('pointsRent')?.get('totalPoints').enabled) {
  <unite-list-item-read classItem="red" [label]="'WWS-points by estimation' | translate" type="decimal" tooltip="De berekende punten van het pand. Deze worden berekend op basis van de belangrijkste factoren: oppervlakte, energielabel en WOZ-waarde. Er kunnen extra punten worden toegekend bij bijvoorbeeld extra voorzieningen, een luxe afwerking, extra buitenruimte, een parkeerplaats, of indien het pand een rijksmonument of stadsgezicht betreft." [value]="form.get('pointsRent')?.get('totalPoints').value">
  </unite-list-item-read>
}

@if (form.get('pointsRent')?.get('manualPoints').enabled) {
  <unite-list-item-input classItem="red" [label]="'WWS-points by landlord' | translate" type="decimal" [control]="form.get('pointsRent')?.get('manualPoints')">
  </unite-list-item-input>
}

@if (showRecentValuation(form)) {
  <span>
    <label class="small-text" translate="" [translateParams]="{ valuator: recentValuation.valuator.name, date: recentValuation.date | date: 'shortDate' }">Valuated by ... on ...</label>
  </span>
}

@if (showCustomerName()) {
  <unite-list-item-read [label]="'Owners' | translate" type="text" [value]="model.customerName">
  </unite-list-item-read>
}
</mat-list>
</div>
</div>

<ng-template #tplRent="" let-form="">

  @if (form.get('numberOfRentalContracts')?.enabled) {
    <unite-list-item-input [label]="'Number of rooms' | translate" type="digits" [control]="form.get('numberOfRentalContracts')" [tooltip]="'The number of rooms on this property.' | translate">
    </unite-list-item-input>
  }

  @if (form.get('sublet')?.enabled) {
    <unite-list-item-select [label]="'Rental through company?' | translate" type="boolean" [control]="form.get('sublet')">
    </unite-list-item-select>
  }

  @if (form.get('rentedTo')?.enabled) {
    <mat-list-item>
      <label matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" matTooltip="Aan wie wordt het pand verhuurd?">
        <span translate="">Rented to</span>
      </label>
      <mat-form-field floatLabel="never" class="inline-field">
        <mat-select placeholder="..." [formControl]="form.get('rentedTo')">
          <mat-option [value]="'Family'"><span translate="">Single / family</span></mat-option>
          @if (form.get('rentalType')?.value === 'RoomRental' || form.get('rentalType')?.value === 'HouseSharing') {
            <mat-option [value]="'Students'">
              <span translate="">Students</span>
            </mat-option>
          }
          @if (form.get('rentalType')?.value !== 'Regular') {
            <mat-option [value]="'LaborOrKnowledgeMigrants'">
              <span translate="">Labor / knowledge migrants</span>
            </mat-option>
          }
          @if (form.get('rentalType')?.value === 'ShortStay') {
            <mat-option [value]="'Tourists'">
              <span translate="">Tourists</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-list-item>
  }

</ng-template>

<mat-action-row class="flex justify-end content-center items-center">

  <div class="flex-1">

    @if (limitedByPointsRent) {
      <div class="card-warning flex flex-col gap-[1rem]" style="font-style: italic">
        <div>
          <mat-icon color="warn" class="mr1">feedback</mat-icon>
          @if (!model.building.pointsRent.manualPoints) {
            <span translate="" [translateParams]="{ value : model.building.pointsRent.rent | currency:'EUR':'symbol':'1.0-0'  }">According to our estimate, the house does not fall into the private sector and there is a maximum rent that can be charged. The rent is according to the points system (home valuation system) at ... per month.</span>
          }
          @if (model.building.pointsRent.manualPoints) {
            <span translate="" [translateParams]="{ value : model.building.pointsRent.rent | currency:'EUR':'symbol':'1.0-0'  }">The maximum rent according to the points system (home valuation system) is .... As a result, the house does not fall into the private sector. The lender will therefore not calculate the rental income, but this limited rent.</span>
          }
        </div>
        @if (!model.building.pointsRent.manualPoints) {
          <div>{{ 'If the house is in the private sector, click Save. If you are not sure, enter the points according to the landlord or adjust the rent per month downwards. Then click Save.' | translate }}</div>
        }
        @if (!model.building.pointsRent.manualPoints) {
          <div>{{ 'If the appraisal later shows that the appraised monthly rent is lower than entered, there is a chance that the loan will be lower.' | translate }}</div>
        }
      </div>
    }

    @if (showPurchaseProtectionAct(form)) {
      <div class="card-warning flex flex-row" style="font-style: italic">
        <div><mat-icon color="warn" class="mr1">feedback</mat-icon></div>
        <div>
          <span translate="" [translateParams]="{ area: purchaseProtectionAct.areaMatched, max: purchaseProtectionAct.maxEstimatedValueByMunicipality | currency:'EUR':'symbol':'1.0-0'}">Purchase protection act applies in ... for homes with a max estimated value by municipality of ...</span>.
          <a target="_blank" [href]="purchaseProtectionAct.source" translate="">Read more</a>.
        </div>
      </div>
    }

  </div>

  <div class="flex justify-start content-center items-center">

    @if (options.showSoldButton) {
      <unite-loading-button (click)="sold()" icon="euro_symbol" [matStrokedButton]="true" [loading]="model.isProcessingSold" [text]="'Sold' | translate"></unite-loading-button>
    }

    @if (options.showRemoveButton) {
      <unite-loading-button (click)="remove()" icon="clear" color="warn" [matStrokedButton]="true" [loading]="model.isProcessingRemoved" [text]="'Remove' | translate"></unite-loading-button>
    }

    @if (options.showIgnoreButton) {
      <unite-loading-button (click)="ignore()" [matStrokedButton]="true" [text]="'Skip building' | translate"></unite-loading-button>
    }

    <unite-loading-button (click)="saveBuildingClick()" icon="check" [text]="'Save' | translate"></unite-loading-button>
  </div>
</mat-action-row>
</mat-expansion-panel>